<template>
    <div class="content-wrapper">

        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.partnerList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <b-card :header="$t('form.setting.partnerList')" header-bg-variant="light" body-class="p-0">
                    <table class="table table-hover" v-if="partners.length">
                        <thead>
                            <th>{{$t('form.setting.partnerCode')}}</th>
                            <th>{{$t('form.setting.partnerName')}}</th>
                            <th>{{$t('form.setting.active')}}</th>
                            <th>{{$t('form.setting.sortOrder')}}</th>
                            <th class="text-right">{{$t('form.setting.action')}}</th>
                        </thead>

                        <tbody>
                            <tr v-for="(partner,index) in partners" :key="index" @dblclick="edit(partner.PartnerID)">
                                <td>{{partner.PartnerCode}}</td>
                                <td>{{partner.PartnerName}}</td>
                                <td>
                                    <b-badge variant="success" v-if="partner.PartnerActive">{{$t('form.setting.yes')}}
                                    </b-badge>
                                    <b-badge variant="danger" v-else>{{$t('form.setting.no')}}</b-badge>
                                </td>
                                <td>{{partner.PartnerSortOrder}}</td>
                                <td class="text-right">
                                    <b-button variant="info" size="sm" @click="edit(partner.PartnerID)"
                                        v-if="permissions.viewSettingsPartners">
                                        <span class="fa fa-edit"></span></b-button>

                                    <b-button variant="danger" size="sm" @click="remove(partner.PartnerID, index)"
                                        v-if="permissions.deleteSettingsPartners">
                                        <span class="fa fa-trash"></span>
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </b-card>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                pagination: {
                    current_page: 1
                },

                partners: [],
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsPartners) {
                return this.$router.push('/');
            }

            this.fetch();
        },

        methods: {

            paginate() {
                this.fetch();
            },

            fetch() {
                this.isLoading = true;

                axios
                    .get('/api/partners?page=' + this.pagination.current_page)
                    .then((response) => {
                        this.partners = response.data.data.data;
                        this.pagination = response.data.pagination;

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log(error.response)

                        this.isLoading = false;
                    });
            },

            edit(id) {
                if (!this.permissions.viewSettingsPartners) return;

                this.$router.push({
                    name: 'PartnerEdit',
                    params: {
                        id: id
                    }
                });
            },

            remove(id, index) {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    this.isLoading = true;

                    axios
                        .delete('/api/partners/' + id)
                        .then(response => {
                            if (response.data.success) {
                                this.partners.splice(index, 1);

                                this.isLoading = false;
                                this.showAlert(response.data.message);
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;

                            this.showAlert(error.response.data.message, 'danger');
                        });
                }
            },

            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
